import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrClosing } from '../../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../../shared/utils/useGetNameOrValue';

export const usePqrNonComplianceReason = (closing?: PqrClosing) => {
    const formik = useFormik({
        initialValues: {
            nonComplianceReason: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            nonComplianceReason: useGetNameOrValue(
                closing?.nonComplianceReason || ''
            ),
        });
    }, [closing]);

    return {
        formik,
    };
};
